export const DISPLAY_PLANNER_DRAWER = 'zola/overview/DISPLAY_PLANNER_DRAWER';
export const CLOSE_PLANNER_DRAWER = 'zola/overview/CLOSE_PLANNER_DRAWER';
export const SHOW_REQUIRED_FIELDS_ERROR = 'zola/overview/SHOW_REQUIRED_FIELDS_ERROR';
export const HIDE_REQUIRED_FIELDS_ERROR = 'zola/overview/HIDE_REQUIRED_FIELDS_ERROR';
export const HYDRATE_PLANNER_SUGGESTIONS = 'zola/overview/HYDRATE_PLANNER_SUGGESTIONS';
